/**
 * App Light Theme
 */
import { createMuiTheme } from "@material-ui/core/styles";
import AppConfig from "Constants/AppConfig";

function setAppConfig() {
  let appConfig = localStorage.getItem("APP_CONFIG");
  if (appConfig) {
    appConfig = JSON.parse(appConfig);
    AppConfig.sidebarTenantLogo = appConfig.portalSidebarImage;
    AppConfig.themeColors.primary = appConfig.primaryColor;
    AppConfig.themeColors.primaryDark = appConfig.primaryDark;
    AppConfig.themeColors.secondary = appConfig.secondaryColor;
    AppConfig.themeColors.portalFontColor = appConfig.portalFontColor;
    document
      .querySelector("body")
      .style.setProperty("--primary", AppConfig.themeColors.primary);
    document
      .querySelector("body")
      .style.setProperty("--primaryDark", AppConfig.themeColors.primaryDark);
    document
      .querySelector("body")
      .style.setProperty(
        "--portalFontColor",
        AppConfig.themeColors.portalFontColor
      );
    document
      .querySelector("body")
      .style.setProperty("--secondary", AppConfig.themeColors.secondary);
  }
}
setAppConfig();
const theme = createMuiTheme({
  palette: {
    primary: {
      main: AppConfig.themeColors.secondary
    },
    secondary: {
      main: AppConfig.themeColors.primary
    }
  },
  typography: {
    useNextVariants: true
  }
});

export default theme;
